document.addEventListener('DOMContentLoaded', function() {
    let addToCartBtn = document.querySelector('.button--add-to-cart');
    let quantityElement = document.querySelector('.quantity-input');
    
    if(addToCartBtn){
        if (!addToCartBtn.classList.contains("ajax-submit") && !addToCartBtn.classList.contains("article-button")) {
          $('.button--add-to-cart').click(function(e){
            let quantity = quantityElement.value;
            e.preventDefault()
            var that = this;
            let all_options_selected = true    
            if(all_options_selected){
                    
              // check for selected bundled products and add to cart before submitting form
      
              var formData = {'items':[]}
      
      
              if(document.querySelector(".select-bundle-1")){
                if(document.querySelector("#bundled_product_1_checkbox").checked){
                  var bundle_item_1_id = document.querySelector(".select-bundle-1").value;
                  formData.items.push({'id': `${bundle_item_1_id}`,'quantity': 1})
                }
              }
        
              if(document.querySelector(".select-bundle-2")){
                if(document.querySelector("#bundled_product_2_checkbox").checked){
                  var bundle_item_2_id = document.querySelector(".select-bundle-2").value;
                  formData.items.push({'id': `${bundle_item_2_id}`,'quantity': 1})
                }
              }
      
                console.log("this  runs")
                console.log(JSON.stringify(formData))        
      
               fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              })
              .then( ()=> {
                $(that).parents('.shopify-product-form').submit();
                return
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
          })
        }
      }
    
});



